import { useEffect, useState } from 'react';
import { apiService } from '../../services/api';
import { isManagementAdmin } from './isAdminEmployeeCode';

/** Client allowlist first, then confirm against ASP-Admin (JWT employee id — works for doctor OWH). */
export function useManagementAccess(
  code?: string | null,
  roleId?: number | null,
  username?: string | null,
): boolean {
  const [allowed, setAllowed] = useState(() => isManagementAdmin(code, roleId, username));

  useEffect(() => {
    setAllowed(isManagementAdmin(code, roleId, username));
    let cancelled = false;
    void apiService
      .getTeleconsultManagementAccess()
      .then((r) => {
        if (!cancelled) setAllowed(r.allowed || isManagementAdmin(code, roleId, username));
      })
      .catch(() => {
        if (!cancelled) setAllowed(isManagementAdmin(code, roleId, username));
      });
    return () => {
      cancelled = true;
    };
  }, [code, roleId, username]);

  return allowed;
}
